<template>
  <table class="table">
    <tr
      v-for="(additional_info, index) in additionalInformation"
      :key="index"
    >
      <th>{{ additional_info.key }}</th>
      <td class="fw-bold">{{ additional_info.value }}</td>
    </tr>
  </table>
</template>

<script>
export default {
  props:{
    additionalInformation: {
      type: Array
    }
  }
}
</script>
